import { useEffect, useState } from "react";

import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";

import { getRequestStatuses } from "../../api";

export const useRequestStatuses = () => {
  const [requestStatuses, setRequestStatuses] = useState<CodeBook[]>([]);

  useEffect(() => {
    (async () => {
      const requestStatuses = await getRequestStatuses();
      setRequestStatuses(requestStatuses);
    })();
  }, []);

  return requestStatuses;
};
